
import React, { Component } from "react";
import Config from "../../../config";
import { Modal, Button,Radio,Input,Checkbox } from 'antd';
import { tsDateToThaiDate } from "../../../utils/func";
import Iframe from "react-iframe";
const RadioGroup = Radio.Group;
const { TextArea } = Input;

class Xpagenewtab13 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
   

  
  }


  render() {
    let { year ,plt_bld_id } = this.props
    let url = `http://122.155.13.121/Eform/EformExcelPreview.aspx?plt_bld_id=${plt_bld_id}&year=${year}&ACC_ID=kultida@chuyo.co.th&ACC_PASS=6596461`;

    return <div>
        <div className="myForm-2" style={{ minHeight: "530px" }}>
          <Iframe url={url} width="100%" height="750px" id="myId" className="myClassname" display="initial" position="relative" allowFullScreen />
        </div>
      </div>;
  }
}

export default Xpagenewtab13;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/newtab13.js